module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    attrs: {
      "title": "Resend Email Confirmation"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8-tablet is-6-desktop is-offset-3-desktop is-offset-2-tablet is-one-third-fullhd is-offset-one-third-fullhd"
  }, [_c('section', {
    staticClass: "mt-4"
  }, [_c('h1', {
    staticClass: "title is-2 mb-2"
  }, [_vm._v("Email Confirmation Required")]), _vm._v(" "), _c('p', [_vm._v("You need to confirm your email address before you can access all of the platform")]), _vm._v(" "), _c('section', {
    staticClass: "d-flex justify-content-between flex-align-center mt-2"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: _vm.loading && 'is-loading',
    on: {
      "click": function($event) {
        _vm.resend()
      }
    }
  }, [_vm._v("\n            Resend Email\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-ee2820b8"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResendEmailConfirmation.vue
// module id = 1095
// module chunks = 0